'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function MortgageBackup() {
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController];
  this.dataSanitization = new DataSanitization();
  this._hasSubmitted = false;
  this._tmpValues = {
    address: '',
    suite: '',
    city: '',
    province: '',
    postal_code: ''
  };
  this._$warning = null;
  this._sanitizeEmailTimer = 0;
  this._copilotTooltip = null;

  this.init = function () {
    this._super();
  };
  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    this.$node = $(this.node);
    this._$form = this.$node.find('form');

    // Tooltip
    this._copilotTooltip = this.$node.find('.js--copilot-tooltip').mogo().create('ToolTip', {
      targetElementId: 'tooltip-copilot',
      hover: true,
      center: true,
      closeIcon: false
    });

    // set correct erros
    this._$jsEmailSameAs = $('.js-email-error-sameas');
    this._$jsEmailDefault = $('.js-email-error-default');
    this._$jsEmailSameAs.hide();

    if (this.checkMortgageApplicationEligibility()) {
      // cache list of feilds
      this._$address = this.$node.find('[name="address"]');
      this._$suite = this.$node.find('[name="suite"]');
      this._$city = this.$node.find('[name="city"]');
      this._$province = this.$node.find('[name="province"]');
      this._$postalCode = this.$node.find('[name="postal_code"]');
      this._$backupOrSoloOption = this.$node.find('[name="backupOrSoloOption"]');
      this._$email = this.$node.find('[name="email_address"]');

      // set initial values
      if (this.presenter.getModelProperty('mortgage_coparticipant.address_is_the_same_as_applicant') === false) {
        this._tmpValues.address = this.presenter.getModelProperty('mortgage_coparticipant.address');
        this._tmpValues.suite = this.presenter.getModelProperty('mortgage_coparticipant.suite');
        this._tmpValues.city = this.presenter.getModelProperty('mortgage_coparticipant.city');
        this._tmpValues.province = this.presenter.getModelProperty('mortgage_coparticipant.province');
        this._tmpValues.postal_code = this.presenter.getModelProperty('mortgage_coparticipant.postal_code');
      }

      // warning setup
      this._$warning = $('#mortgage-warning');
      this._$warning.find('.dialog-prompt__confirm').on('click.confirm', this._confirmWaring.bind(this));
      this._$warning.find('.dialog-prompt__cancel').on('click.cancel', this._hideWarning.bind(this));

      // credit check
      if (this._checkCreditScoreThreshold(this.presenter.getModelProperty('account.credit_score'), this.presenter.getModelProperty('mortgage_settings.credit_score_threshold'))) {
        this._$backupOrSoloOption.filter('[value=false]').attr('disabled', 'disabled').parents('.radio-hero-input-block').addClass('radio-hero-input-block--disabled');
        if (this.presenter.getModelProperty('mortgage.has_supporter') === false) this.presenter.setModelProperty('mortgage.has_supporter'); // change the model property
      }

      // run local functions
      this._extendViewMapsAndValidation();
      this._setFormActionToUpdate();
      this._watchInputs();
      this._setupDateInput();
      this._addComputedVarabiles();
      this.analytics.pushEvent('virtual-page-view');
      this.pushAnalyticsMortgageChoices();
      setTimeout(function () {
        _this.presenter.scanDOM();
      }); // Fix for Samsung S6
    }
  };

  this._checkCreditScoreThreshold = function (score, threshold) {
    return !score || score < threshold;
  };

  this._setupDateInput = function () {
    var _this2 = this;

    this._$bithdateCalendar = $('.js--birthdate-date-calendar');

    this._$bithdateCalendar.mogo().setYearValidation(function (year) {
      var agelimit = moment().subtract(_this2._$province.mogo().val() === 'BC' ? 19 : 18, 'years');
      return agelimit.year() >= year;
    });

    this._$bithdateCalendar.mogo().setMonthValidation(function (year, month) {
      var agelimit = moment().subtract(_this2._$province.mogo().val() === 'BC' ? 19 : 18, 'years');
      return agelimit.year() > year || agelimit.year() === year && agelimit.month() >= month;
    });

    this._$bithdateCalendar.mogo().setDateValidation(function (year, month, date) {
      var agelimit = moment().subtract(_this2._$province.mogo().val() === 'BC' ? 19 : 18, 'years');
      return agelimit.year() > year || agelimit.year() === year && agelimit.month() >= month && agelimit.date() >= date;
    });
  };

  this._extendViewMapsAndValidation = function () {
    // remove the string from the array created by BooleanGroup
    this.presenter.extendViewMap({
      'mortgage_coparticipant.type': {
        get: function get(value) {
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') return value[0];
          return value;
        },
        set: function set(value) {
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') return value[0];
          return value;
        }
      },

      'mortgage_coparticipant.postal_code': {
        get: function get(value) {
          if (!value || value.length < 1) return value;
          value = value.toUpperCase().replace(' ', '').split('');
          value.splice(3, 0, ' ');
          return value.join('');
        },
        set: function set(value) {
          if (!value || value.length < 1) return value;
          value = value.toUpperCase().replace(' ', '').split('');
          value.splice(3, 0, ' ');
          return value.join('');
        }
      }
    });

    // prehook callback for extendCustomValidations
    var prehook = function prehook() {
      // remove validation
      this._$form.mogo().removeAllValidationPaths();

      // add correct validation
      this._$form.mogo().addValidationExcludePath(this.presenter.getModelProperty('mortgage.type') === 'refinance' ? '#/oneOf/0' : '#/oneOf/1');
      this._$form.mogo().addValidationExcludePath('#/oneOf/2');
    };

    this.presenter.extendCustomValidations('mortgage_coparticipant.update_mortgage_participant', {
      _hooks: { prehook: prehook.bind(this) },
      phone_number: { sanitize: this.dataSanitization.sanitizePhone },
      email_address: { sanitize: this._sanitizeEmailAddress.bind(this) }
    });

    this.presenter.extendCustomValidations('mortgage.create_mortgage_participant', {
      _hooks: { prehook: prehook.bind(this) },
      phone_number: { sanitize: this.dataSanitization.sanitizePhone },
      email_address: { sanitize: this._sanitizeEmailAddress.bind(this) }
    });

    // mask phone number
    this.presenter.extendViewMap({
      'mortgage_coparticipant.phone_number': {
        get: this.dataSanitization.sanitizePhone,
        set: this.dataSanitization.sanitizePhone
      },
      'mortgage.phone_number': {
        get: this.dataSanitization.sanitizePhone,
        set: this.dataSanitization.sanitizePhone
      },
      'mortgage_coparticipant.mortgage_application_type': {
        set: function set(value) {
          return value;
        }
      }
    });
  };

  this._sanitizeEmailAddress = function (email) {
    if (String(email).toLowerCase() === String(this.presenter.getModelProperty('account.email_address')).toLowerCase()) {
      // check time since last sanitize
      var dateTime = new Date().getTime();
      var isRepeatValidate = dateTime - this._sanitizeEmailTimer < 1000;
      this._sanitizeEmailTimer = new Date().getTime();

      this._$jsEmailSameAs.show();
      this._$jsEmailDefault.hide();
      if (!isRepeatValidate) {
        this.analytics.forcePushEvent('form-errors', { FormErrors: ['Email Same As Applicant'] });
      }
    } else {
      // switch back to default error message
      this._$jsEmailSameAs.hide();
      this._$jsEmailDefault.show();
      return email;
    }
  };

  // add computed variables
  this._addComputedVarabiles = function () {
    var _this3 = this;

    // pass the creditScoreThreshold to the view
    this.presenter.addComputedVariable('checkCreditScoreThreshold', ['account.credit_score', 'mortgage_settings.credit_score_threshold'], this._checkCreditScoreThreshold.bind(this));

    // set state based on same as applicant checkbox
    this.presenter.addComputedVariable('sameAsApplicant', ['mortgage_coparticipant.address_is_the_same_as_applicant'], function (boolean) {
      _this3._updateAddressInputs(boolean);
    });

    // run computed variable on load
    this._updateAddressInputs(this.presenter.getModelProperty('mortgage_coparticipant.address_is_the_same_as_applicant'));

    // check on field change
    this.presenter.addComputedVariable('provinceCheck', ['mortgage_coparticipant.province'], this._provinceCheck.bind(this));
  };

  this._provinceCheck = function (province) {
    // check if the birthdate is still valid
    if (typeof moment !== 'undefined' && province === 'BC') {
      if (moment(this._$bithdateCalendar.mogo().val()) > moment().subtract(19, 'years')) {
        this.presenter.setModelProperty('mortgage_coparticipant.birth_date', ''); // clear the dob if doesn't work for current province
      }
    }
  };

  // change form to update if they already have a participant
  this._setFormActionToUpdate = function () {
    // setup form in update state
    if (this.presenter.hasAction('mortgage_coparticipant.update_mortgage_participant')) {
      this.presenter.addActionToNode(this._$form[0], 'mortgage_coparticipant.update_mortgage_participant');
      this._$form.attr('data-analytics-id', 'MogoMortgage-Form submission-Applicant Info-null-Form');

      // add action for form
      this._submitBackup = [this.presenter.addCallbackToAction('mortgage_coparticipant.update_mortgage_participant', this._onSubmitBackup.bind(this)), 'mortgage_coparticipant.update_mortgage_participant'];
    } else {
      // setup form in create state
      this.presenter.addActionToNode(this._$form[0], 'mortgage.create_mortgage_participant');
      this._$form.attr('data-analytics-id', 'MogoMortgage-Form submission-Applicant Info-null-Form');

      // add action for form
      this._submitBackup = [this.presenter.addCallbackToAction('mortgage.create_mortgage_participant', this._onSubmitBackup.bind(this)), 'mortgage.create_mortgage_participant'];
    }
  };

  this._watchInputs = function () {
    var _this4 = this;

    // watch has supporter
    this._$backupOrSoloOption.on('change.has_supporter', this._validateHasSupporter.bind(this));

    // watch for changes on address fields
    this._$address.on('keyup.savelocalstate', function () {
      if (!_this4.presenter.getModelProperty('mortgage_coparticipant.address_is_the_same_as_applicant')) {
        _this4._tmpValues.address = _this4._$address.mogo().val();
      }
    });

    this._$suite.on('keyup.savelocalstate', function () {
      if (!_this4.presenter.getModelProperty('mortgage_coparticipant.address_is_the_same_as_applicant')) {
        _this4._tmpValues.suite = _this4._$suite.mogo().val();
      }
    });

    this._$city.on('keyup.savelocalstate', function () {
      if (!_this4.presenter.getModelProperty('mortgage_coparticipant.address_is_the_same_as_applicant')) {
        _this4._tmpValues.city = _this4._$city.mogo().val();
      }
    });

    this._$province.on('change.savelocalstate', function () {
      if (!_this4.presenter.getModelProperty('mortgage_coparticipant.address_is_the_same_as_applicant')) {
        _this4._tmpValues.province = _this4._$province.mogo().val();
      }
    });

    this._$postalCode.on('keyup.savelocalstate', function () {
      if (!_this4.presenter.getModelProperty('mortgage_coparticipant.address_is_the_same_as_applicant')) {
        _this4._tmpValues.postal_code = _this4._$postalCode.mogo().val();
      }
    });

    this.$node.find('#mortgage_backup_solo_button').on('click.savestate', this._updateMortgageSupporter.bind(this));
  };

  this._validateHasSupporter = function (e) {
    if ($(e.target).parents('[data-mogo-ui="BooleanGroup"]').mogo().val() != null) {
      this.$node.find('[name="backupOrSolo"]').mogo().hideError();
    }
  };

  this._updateAddressInputs = function (boolean) {
    if (!boolean) {
      // change values back to previous values
      this.presenter.setModelProperty(this._$address.attr('data-bind'), this._tmpValues.address);
      this.presenter.setModelProperty(this._$suite.attr('data-bind'), this._tmpValues.suite);
      this.presenter.setModelProperty(this._$city.attr('data-bind'), this._tmpValues.city);
      this.presenter.setModelProperty(this._$postalCode.attr('data-bind'), this._tmpValues.postal_code);

      // set province to empty or to old value
      this.presenter.setModelProperty(this._$province.attr('data-bind'), this._tmpValues.province);
      if (this._tmpValues.province === '' || typeof this._tmpValues.province === 'undefined') {
        this._$province.mogo().setSelectedIndex(0);
      }

      // enable inputs
      this._$address.mogo().setReadOnly(false);
      this._$suite.mogo().setReadOnly(false);
      this._$city.mogo().setReadOnly(false);
      this._$province.mogo().setReadOnly(false);
      this._$postalCode.mogo().setReadOnly(false);
    } else {
      // changes values to same as applicant values and disable fields
      this.presenter.setModelProperty(this._$address.attr('data-bind'), this.presenter.getModelProperty('account.address'));
      this.presenter.setModelProperty(this._$suite.attr('data-bind'), this.presenter.getModelProperty('account.suite'));
      this.presenter.setModelProperty(this._$city.attr('data-bind'), this.presenter.getModelProperty('account.city'));
      this.presenter.setModelProperty(this._$province.attr('data-bind'), this.presenter.getModelProperty('account.province'));
      this.presenter.setModelProperty(this._$postalCode.attr('data-bind'), this.presenter.getModelProperty('account.postal_code'));

      // disable inputs
      this._$address.mogo().setReadOnly(true);
      this._$suite.mogo().setReadOnly(true);
      this._$city.mogo().setReadOnly(true);
      this._$province.mogo().setReadOnly(true);
      this._$postalCode.mogo().setReadOnly(true);

      // Force Validator to revalidate save states
      this._$address.mogo().hideError();
      this._$suite.mogo().hideError();
      this._$city.mogo().hideError();
      this._$province.mogo().hideError();
      this._$postalCode.mogo().hideError();
    }

    this._provinceCheck(this.presenter.getModelProperty(this._$province.attr('data-bind')));

    return boolean;
  };

  // create new co participant
  this._onSubmitBackup = function (data, response) {
    if (response === 200) {
      this._hasSubmitted = true;
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['MogoMortgage-Form submission-Applicant Info-null-Form']
      });

      this.$node.find('#mortgage_coparticipant_button').mogo().setDisabledLoadState();
      this.updateMortgageApplication(this._moveToNextPage.bind(this));
    } else if (response === 400) {
      var invalidEmail = data.errors[0].key == 'json_schema_error_did_not_match_all_of' && data.errors[0].msg == 'Provided email does not have a valid format';
      if (invalidEmail) {
        this._$email.mogo().showError();
        this._$email.mogo().showErrorLabel(true, data.errors[0].msg);
      } else {
        $('#Notification').mogo().get();
        console.error('submit co-pilot form failed', data);
      }
    } else {
      $('#Notification').mogo().get();
      console.error('submit co-pilot form failed', data);
    }
  };

  this._moveToNextPage = function () {
    this.$node.find('#mortgage_coparticipant_button').mogo().removeDisabledLoadState();
    this.$node.find('#mortgage_backup_solo_button').mogo().removeDisabledLoadState();
    this._tray().moveNext();
  };

  this._updateMortgageSupporter = function (e) {
    e.preventDefault();

    // update mortgage to be set to co-pilot / solo
    if (this.presenter.getModelProperty('mortgage.has_supporter') != null) {
      // check if there was a co-pilot previously
      if (this.presenter.models.mortgage._memory.has_supporter) {
        this._$warning.mogo().show();
      } else {
        this._updateMortgageSupporterAction();
      }
    } else {
      this.$node.find('[name="backupOrSolo"]').mogo().showErrorLabel();
      this.analytics.forcePushEvent('form-errors', { FormErrors: ['Backup'] });
    }
  };

  this._hideWarning = function () {
    this._$warning.mogo().hide();
  };

  this._confirmWaring = function () {
    this._$warning.mogo().hide();
    this._updateMortgageSupporterAction();
  };

  // Perform the actual update to the mortgage application
  this._updateMortgageSupporterAction = function () {
    this.$node.find('#mortgage_backup_solo_button').mogo().setDisabledLoadState();
    this.presenter.performAction('mortgage.update_mortgage_application', {
      has_supporter: this.presenter.getModelProperty('mortgage.has_supporter')
    }, this._updateMortgageSuccess.bind(this));
  };

  this._updateMortgageSuccess = function (data, response) {
    if (response === 200) {
      this._hasSubmitted = true;
      // push form success
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['MogoMortgage-Form submission-Applicant Info-null-Form']
      });
      // set modal and continue
      this.updateMortgageApplication(this._moveToNextPage.bind(this));
    } else {
      $('#Notification').mogo().get();
      console.error('failed to update mortgage has supporter', data);
      this.$node.find('#mortgage_backup_solo_button').mogo().removeDisabledLoadState();
    }
  };

  this.destroy = function () {
    this._super();

    if (this._copilotTooltip) this._copilotTooltip.destroy();

    if (this._$warning) this._$warning.mogo().destroy();

    // reset Models
    this.presenter.resetModels('mortgage');
    this.presenter.resetModels('mortgage_coparticipant');

    // remove actions
    if (typeof this._submitBackup !== 'undefined') {
      this.presenter.removeCallbackFromAction(this._submitBackup[1], this._submitBackup[0]);
    }

    if (!this._hasSubmitted) {
      this.analytics.forcePushEvent('form-abandoned', { FormAbandoned: ['backupOrSolo'] });
    }

    // remove computed variables
    this.presenter.removeComputedVariable('checkCreditScoreThreshold');
    this.presenter.removeComputedVariable('sameAsApplicant');
    this.presenter.removeComputedVariable('provinceCheck');
  };
}